import {
  Button,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Row,
  Col,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import envConfig from "../config.json";
import {
  PlusOutlined,
  CloudUploadOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import "@google/model-viewer/dist/model-viewer";
import axios from "axios";
import "./ModelUpload.css";

import { useTheme } from "../components/ThemeContext";
const {
  AnonymousCredential,
  BlobServiceClient,
  newPipeline,
} = require("@azure/storage-blob");

const UpdateModel = (props) => {
  const { instance } = useMsal();
  const [icon, setIcon] = useState();
  const [asset, setAsset] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [formKey, setFormKey] = useState(0);
  const [assetValidation, setAssetValidation] = useState(false);
  const [thumbnailValidation, setThumbnailValidation] = useState(false);
  const [isSaving, setIsSaving] = useState(true);
  const [file, setFile] = useState();
  const { theme } = useTheme();
  const msalToken = localStorage.getItem("msal.accesstoken");
  const filePropsThumbnail = {
    name: "files",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "error") {
        message.error({
          content: `${info.file.name} file upload failed.`,
          className: 'custom-message-failure',
        });
      }
    },
    beforeUpload() {
      return false;
    },
  };
  /**
   * Method to handle icon
   * @param {*} e  an object
   * @returns
   */
  const handleIcon = (e) => {
    const isJpgOrPng =
      e.file.type === "image/jpeg" || e.file.type === "image/png";
    const isLt2M = e.file.size / 1024 / 1024 < 10;
    if (!isJpgOrPng) {
      message.error({
        content: "You can only upload JPG/PNG file",
        className: 'custom-message-failure',
      });
      setThumbnailValidation(true);
      return;
    } else if (!isLt2M) {
      message.error({
        content: "Image must smaller than 10MB",
        className: 'custom-message-failure',
      });
      return;
    }
    const result = URL.createObjectURL(e.file);
    setPreviewImage(result);
    setIcon(e.file);
    setThumbnailValidation(false);
  };
  /**
   * Method to handle blob upload
   * @param {*} file
   * @returns
   */
  const blobUpload = async (file) => {
    const account = envConfig.storageAccount;
    const containerName = envConfig.containerName;
    const orgDir = "AOT";
    let ext = file.name.toLowerCase().split(".");
    ext = ext[ext.length - 1];
    const index = file.name.lastIndexOf(".");
    const name = file.name.substr(0, index);
    const pipeline = newPipeline(new AnonymousCredential(), {
      retryOptions: { maxTries: 4 }, // Retry options
      userAgentOptions: { userAgentPrefix: "AdvancedSample V1.0.0" }, // Customized telemetry string
      keepAliveOptions: {
        enable: false,
      },
    });
    const blobServiceClient = new BlobServiceClient(
      `https://${account}.blob.core.windows.net?${props.sas}`,
      pipeline
    );
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const fileName = `${name}${Date.now()}.${ext}`;
    const blobName = orgDir + "/" + fileName;
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    let url = blockBlobClient.url.split("?");
    url = url[0];
    try {
      await blockBlobClient.uploadData(file, {
        blockSize: 4 * 1024 * 1024, // 4MB block size
        concurrency: 20, // 20 concurrency
        onProgress: (ev) => console.log(ev),
      });
      const fileDetails = {
        name: fileName,
        ext: ext,
        size: file.size,
        url: url,
      };
      return JSON.stringify(fileDetails);
    } catch (err) {
      console.error({ err });
      console.error(
        `uploadFile failed, requestId - ${err.details.requestId}, statusCode - ${err.statusCode}, errorCode - ${err.details.errorCode}`
      );
    }
  };
  /**
   * Function to reset fields
   */
  const resetFields = () => {
    setFormKey((formKey || 0) + 1);
    setFile("");
    setPreviewImage(null);
  };
  /**
   * Function to save model
   */
  const saveModel = async () => {
    if (asset && icon) {
      setShowProgress(true);
      const assetDetails = await blobUpload(asset);
      const thumbnailDetails = await blobUpload(icon);
      const uploadFields = {
        title: props.title,
        asset: JSON.parse(assetDetails),
        icon: JSON.parse(thumbnailDetails),
        plantId: props.selectedPlant,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${msalToken}`,
        },
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .patch(
          `${envConfig.aotmwapi}/api/3d-cms/content/${props.assetId}`,
          uploadFields,
          config
        )
        .then((_response) => {
          setShowProgress(false);
          message.success({
            content: "Model uploaded successfully",
            className: 'custom-message-success',
          });
          resetFields();
          props.handleCancel();
          props.fetchModels();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.removeItem("checkRole");
            const logoutRequest = {
              postLogoutRedirectUri: envConfig.redirectUri,
            };
            instance.logoutRedirect(logoutRequest);
          }
          console.error("error in saveModel");
        });
    } else {
      alert("please fill all fileds");
    }
  };

  /**
   * Function to validate the selected field
   * @param {*} value an object
   * @returns
   */

  const validateSelectedFiles = (value) => {
    if (value.fileList.length > 0) {
      let ext = value.file.name.toLowerCase().split(".");
      ext = ext[ext.length - 1];
      if (ext === "gltf" || ext === "glb") {
        setAssetValidation(false);
        setFile(window.URL.createObjectURL(value.file));
        setAsset(value.file);
      } else {
        setAssetValidation(true);
        setThumbnailValidation(false);
        setFile("");
        setAsset("");
        message.error({
          content: "You can only upload GLB/GLTF file",
          className: 'custom-message-failure',
        });
        return;
      }
    } else {
      setFile("");
      setAsset("");
      setAssetValidation(false);
    }
  };

  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (asset && icon) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
  }, [asset, icon]);

  return (
    <Spin spinning={showProgress}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col className="gutter-row" span={12}>
          <div>
            <Form
              name="model"
              key={formKey}
              layout="vertical"
              initialValues={{
                remember: true,
              }}
              requiredMark={false}
            >
              <Form.Item label="Title" name="title">
                <Input
                  maxLength={50}
                  defaultValue={props.title}
                  readOnly
                  className="title"
                  style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }}
                />
              </Form.Item>
              <Form.Item label="Tag" name="tag">
                <Input defaultValue={props.plantName} readOnly
                  style={{ border: `1px solid ${theme === "dark" ? "#1D5F70" : "#CADCF8"}` }}
                />
              </Form.Item>
              <Row gutter={16}>
                <Col className="gutter-row" span={18}>
                  <Form.Item
                    name="asset"
                    label={
                      <span>
                        3D File<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Upload.Dragger
                      name="asset"
                      maxCount={1}
                      beforeUpload={() => false}
                      onChange={validateSelectedFiles}
                    >
                      <p className="dropzone-icon">
                        <CloudUploadOutlined />
                      </p>
                      <p className="dropzone-text">
                        Drag and drop the asset or click to select files.
                        Please upload GLTF or Glb file only
                      </p>
                    </Upload.Dragger>
                     {assetValidation || thumbnailValidation ? (
                          <p id="error_color">
                            {thumbnailValidation === true ? "Please upload JPG or PNG file only" : "Please upload GLTF or Glb file only"}
                          </p>
                        ) : null}
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label={
                      <span>
                        Thumbnail<span style={{ color: 'red', marginLeft: 4 }}>*</span>
                      </span>
                    }
                    name="Thumbnail"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <div className="clearfix">
                      {/* <Tooltip
                          title="Click to upload new thumbnail"
                          placement="bottomRight"
                        > */}
                      <Upload
                        {...filePropsThumbnail}
                        listType="picture-card"
                        showUploadList={false}
                        onChange={handleIcon}
                        onRemove={() => {
                          setPreviewImage(null);
                        }}
                      >
                        {previewImage ? (
                          <img
                            alt="preview"
                            className="imgWidth"
                            src={previewImage}
                          />
                        ) : (
                          <div>
                            <PlusOutlined />
                            <div className="ant-upload-text">
                              Upload thumbnail
                            </div>
                          </div>
                        )}
                      </Upload>
                      {/* </Tooltip> */}
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
        <Col className="gutter-row" span={12}>
          <div>
            <model-viewer
              src={file}
              shadow-intensity="1"
              camera-controls
              auto-rotate
              ar
              class="modelviewerStyle"
            >
              <div id="lazy-load-poster" slot="poster"></div>
              <div id="button-load" slot="poster">
                <PlayCircleOutlined /> Preview
              </div>
            </model-viewer>
          </div>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={8}>
          <Button className="cancelButton" onClick={props.handleCancel}>
            Cancel{" "}
          </Button>
        </Col>
        <Col span={8} offset={8} className="divAlignRight">
          <Button className="model-confirm-yes"
            style={{
              backgroundColor: isSaving ? "#7a7a7a" : "#1d5f70",
              color: isSaving ? "#999999" : "#01f1ff",
              fontWeight: "700",
              padding: "4px 64px",
            }}
            disabled={isSaving}
            onClick={() => saveModel()}
          >
            Update New Version
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default UpdateModel;
